if (!window.__cardPackPickerInitialized) {
  window.__cardPackPickerInitialized = true;

  // Stop the whole-card click/navigation handler from firing when
  // interacting with the pack picker dropdown.
  ['pointerdown', 'mousedown', 'click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest('.card-pack-picker')) {
        e.stopPropagation();
      }
    }, true);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.card-pack-select');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    var variantId = option.value;
    var available = option.dataset.available === 'true';
    var newPrice = option.dataset.price;
    var newComparePrice = option.dataset.comparePrice;
    var onSale = option.dataset.onSale === 'true';

    var card = select.closest('.card-wrapper');
    if (!card) return;

    card.querySelectorAll('.product-variant-id').forEach(function (input) {
      input.value = variantId;
      input.disabled = !available;
    });

    card.querySelectorAll('button[name="add"]').forEach(function (btn) {
      btn.disabled = !available;

      var addText = btn.dataset.addToCartText;
      var soldOutText = btn.dataset.soldOutText;
      if (!addText || !soldOutText) return;

      var label = btn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
      if (label) {
        label.textContent = available ? addText : soldOutText;
      }
    });

    var priceWrapper = card.querySelector('.price');
    if (priceWrapper && newPrice) {
      priceWrapper.classList.toggle('price--on-sale', onSale);

      var regularEls = priceWrapper.querySelectorAll('.price-item--regular');
      var saleEls = priceWrapper.querySelectorAll('.price-item--sale');

      if (onSale) {
        saleEls.forEach(function (el) { el.textContent = newPrice; });
        priceWrapper.querySelectorAll('.price__sale .price-item--regular').forEach(function (el) {
          el.textContent = newComparePrice;
        });
      } else {
        regularEls.forEach(function (el) { el.textContent = newPrice; });
      }
    }
  });
}